import React from 'react';
export const ArrowLeft = () => {
    return (
        <div className="ArrowLeft__solid-white">
            <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 293.42 999.99"><path d="M268.21,1000A25.2,25.2,0,0,0,290,962.12L73.89,587.56a175.72,175.72,0,0,1,0-175.33L290,37.88a25.24,25.24,0,1,0-43.72-25.24h0L30.17,387a226.54,226.54,0,0,0-.06,225.82L246.32,987.41A25.23,25.23,0,0,0,268.21,1000Z" transform="translate(0 -0.01)"/></svg>
        </div>
    )
}
